var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-badge',{attrs:{"variant":_vm.status_settings[_vm.status].color}},[_vm._v(" "+_vm._s(_vm.status_settings[_vm.status].text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }